import { AnalyticsDispatcher } from '../../internal/AnalyticsDispatcher';
import { withExtra as higherOrder } from '../../extenders';
function withExtra(key, value) {
    return higherOrder(key, value)(this);
}
AnalyticsDispatcher.prototype.withExtra = withExtra;
//# sourceMappingURL=withExtra.js.map